export const APP_MIN_WIDTH_PX = 1024
export const PROJECT_NR_PER_PAGE = 10
